import * as yup from 'yup';

import { FINANCE_NUMBER_PATTERN } from '@/constants/patterns';

import { TranslatorFunction } from '@/types/i18n';

const MAX_TYPE_LENGTH = 30;
const MAX_VALUE_DIGITS = 12;

export function getAssetsValidationSchema(t: TranslatorFunction) {
  return yup.object().shape({
    assets: yup
      .array()
      .of(
        yup.object().shape({
          assetType: yup
            .string()
            .required(t('moreInfo.form.yourFinances.assets.assetTypeRequired'))
            .max(
              MAX_TYPE_LENGTH,
              t('moreInfo.form.yourFinances.assets.assetTypeMaxLength'),
            ),
          amount: yup
            .string()
            .required(t('moreInfo.form.yourFinances.assets.valueRequired'))
            .matches(
              FINANCE_NUMBER_PATTERN,
              t('moreInfo.form.yourFinances.assets.valuePattern'),
            )
            .max(
              MAX_VALUE_DIGITS,
              t('moreInfo.form.yourFinances.assets.valueMaxLength'),
            ),
        }),
      )
      .required(),
  });
}
